import { ApplicationRef, inject, Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { LocalStorageService } from '../localStorage/local-storage.service';

@Injectable({
    providedIn: 'root'
})
export class SocketNoticeService extends Socket {

    // ============================================================
    // 🔹 Dependencies & Services
    // ============================================================
    private localStorageService = inject(LocalStorageService);


    constructor(
        appRef: ApplicationRef
    ) {
         const userRaw = localStorage.getItem('currentUser') || '{}';
        let userDetails: any = {};
        try {
            userDetails = JSON.parse(userRaw);
        } catch (error) {
            console.error(error);
        }
        super({
            url: 'wss://api.crizac.com',
            options: {
                transports: ['websocket'],
                forceNew: true,
                timeout: 5000,
            },
        },
            appRef
        );
    }
}
